/**
 * Resolve the stroke kind used for warmup tagging / topspin volume counting.
 * Sequence subtype names win over a multi-kind parent recipe (recipeKind null).
 */

export function subtypeLooksFhTopspin(subtypeName) {
  const n = String(subtypeName || "")
    .trim()
    .toLowerCase();
  if (!n) return false;
  const hasFh = /forehand|coup droit|vorhand/.test(n);
  const hasTop = /topspin|lift|loop/.test(n);
  return hasFh && hasTop;
}

export function subtypeLooksBhTopspin(subtypeName) {
  const n = String(subtypeName || "")
    .trim()
    .toLowerCase();
  if (!n) return false;
  const hasBh = /backhand|revers|rückhand|rckhand|revés/.test(n);
  const hasTop = /topspin|lift|loop/.test(n);
  return hasBh && hasTop;
}

function subtypeBlob(labels = {}) {
  return [labels.subtypeNameEn, labels.subtypeNameFr, labels.sequenceLabels]
    .filter(Boolean)
    .join(" ");
}

/**
 * @param {{
 *   recipeKind?: string|null,
 *   recipeKinds?: string[]|null,
 *   typeNameEn?: string,
 *   subtypeNameEn?: string,
 *   subtypeNameFr?: string,
 *   sequenceLabels?: string,
 * }} [opts]
 * @returns {string}
 */
export function resolveEffectiveStrokeClipKind(opts = {}) {
  const sub = subtypeBlob(opts);
  if (subtypeLooksFhTopspin(sub)) return "forehand_topspin";
  if (subtypeLooksBhTopspin(sub)) return "backhand_topspin";

  const primary = String(opts.recipeKind || "").trim();
  if (primary) return primary;

  const kinds = Array.isArray(opts.recipeKinds)
    ? opts.recipeKinds.map((k) => String(k || "").trim()).filter(Boolean)
    : [];
  if (kinds.length === 1) return kinds[0];

  const fhKinds = kinds.filter((k) => k === "forehand" || k === "forehand_topspin");
  if (fhKinds.length === 1 && fhKinds[0] === "forehand_topspin") {
    return "forehand_topspin";
  }
  const bhKinds = kinds.filter((k) => k === "backhand" || k === "backhand_topspin");
  if (bhKinds.length === 1 && bhKinds[0] === "backhand_topspin") {
    return "backhand_topspin";
  }
  return "";
}

export function isTopspinWarmupClipKind(clipKind) {
  return clipKind === "forehand_topspin" || clipKind === "backhand_topspin";
}
